import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyDocument({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.798 150.012C138.552 144.582 100.5 162.5 75.5 162.5c-40.5 0-80.224-29.026-67.63-69.992 12.886-41.912 44.954-32.484 107.288-71.785 57.405-36.194 102.489 19.812 111.611 51.522 9.122 31.71 3.71 85.056-48.971 77.767z"
        fill="#E9EDFB"
      />
      <path
        opacity={0.32}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.808 112.988C31 125.537 64.662 128.002 119.5 110.5c54.611-17.429 85.52-2.156 105.51 16.304-6.979 15.827-21.438 26.774-47.212 23.208-24.062-3.33-47.675 2.118-68.107 6.832-12.893 2.974-24.519 5.656-34.19 5.656-33.353 0-66.18-19.685-69.693-49.512z"
        fill="#8F9DD6"
      />
      <g filter="url(#pic-empty-document_svg__filter0_d_985_1443)">
        <rect x={61} y={27} width={95} height={114} rx={4} fill="#fff" />
      </g>
      <rect x={71} y={44} width={24} height={12} rx={2} fill="#CCD2EE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71 65a1 1 0 011-1h73a1 1 0 011 1v4a1 1 0 01-1 1H72a1 1 0 01-1-1v-4zm0 12a1 1 0 011-1h73a1 1 0 011 1v4a1 1 0 01-1 1H72a1 1 0 01-1-1v-4zm1 12a1 1 0 00-1 1v4a1 1 0 001 1h28a1 1 0 001-1v-4a1 1 0 00-1-1H72z"
        fill="#E3E8E8"
      />
      <g filter="url(#pic-empty-document_svg__filter1_d_985_1443)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109 104.286a4 4 0 00-4 4v46.857a4 4 0 004 4h72a4 4 0 004-4v-46.857a4 4 0 00-4-4h-72zM134.429 110a2 2 0 00-2 2v.571a2 2 0 002 2h21.142a2 2 0 002-2V112a2 2 0 00-2-2h-21.142z"
          fill="#6C7EC9"
        />
        <path
          d="M137 88a2 2 0 012-2h12a2 2 0 012 2v24.429a1 1 0 01-1 1h-14a1 1 0 01-1-1V88z"
          fill="#717074"
        />
        <circle cx={145} cy={94} r={3.43} fill="#fff" />
        <circle cx={127.29} cy={135.71} r={13.14} fill="#fff" />
        <mask
          id="pic-empty-document_svg__a"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={114}
          y={122}
          width={27}
          height={27}
        >
          <circle cx={127.29} cy={135.71} r={13.14} fill="#fff" />
        </mask>
        <g mask="url(#pic-empty-document_svg__a)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M127.286 138.571a5.714 5.714 0 100-11.428 5.715 5.715 0 100 11.428zm0 .572c-6.312 0-11.429 5.117-11.429 11.428 0 3.429 22.857 2.858 22.857 0 0-6.311-5.116-11.428-11.428-11.428z"
            fill="#8F9DD6"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M146.143 127a1 1 0 011-1h15.143a1 1 0 011 1v1.429a1 1 0 01-1 1h-15.143a1 1 0 01-1-1V127zm0 8a1 1 0 011-1h27.714a1 1 0 011 1v1.429a1 1 0 01-1 1h-27.714a1 1 0 01-1-1V135zm1 7a1 1 0 00-1 1v1.429a1 1 0 001 1h27.714a1 1 0 001-1V143a1 1 0 00-1-1h-27.714z"
          fill="#CCD2EE"
        />
      </g>
      <defs>
        <filter
          id="pic-empty-document_svg__filter0_d_985_1443"
          x={57}
          y={25}
          width={103}
          height={122}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_985_1443" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_985_1443" result="shape" />
        </filter>
        <filter
          id="pic-empty-document_svg__filter1_d_985_1443"
          x={101}
          y={84}
          width={88}
          height={81.14}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_985_1443" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_985_1443" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicEmptyDocument.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyDocument.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyDocument svgRef={ref} {...props} />
));
export default ForwardRef;
